document.addEventListener("DOMContentLoaded", function() {
  // Get the current page URL
  var currentPageURL = window.location.href.split('#')[0].split('?')[0]; // Excluding hash and query parameters

  // Select all anchor tags
  var anchorTags = document.querySelectorAll('.layout--footer-group  a');

  // Loop through each anchor tag
  anchorTags.forEach(function(anchor) {
    // Get the href attribute of the anchor tag
    var anchorHref = anchor.href.split('#')[0].split('?')[0]; // Excluding hash and query parameters

    // Compare the anchor's href with the current page URL
    if (anchorHref === currentPageURL) {
      // Add the desired class if they match
      anchor.classList.add('current-page-link');
    }
  });
});